import type { RetrievalQueueItem } from '@jq4race/shared';

import { formatWaitTime } from '../../domain/format-wait-time';
import { PickupRow } from './PickupRow';

interface MyActiveTicketsProps {
  items: RetrievalQueueItem[];
  /** JQ4-26: callback to initiate delivery confirm flow */
  onDeliver?: (id: string) => void;
  /** JQ4-26: id of the ticket currently being delivered (disables button) */
  deliveringId?: string | null;
  /** post-payment-delay-recharge S1: callback to mark a ticket ready for pickup */
  onMarkReady?: (id: string) => void;
  /** post-payment-delay-recharge S1: id of the ticket currently being marked ready (disables button) */
  markingReadyId?: string | null;
  /** JQ4-38: callback to open cash payment dialog for a ticket */
  onRegisterCash?: (id: string) => void;
  /** JQ4-38: id of the ticket whose cash payment is in-flight */
  registeringCashId?: string | null;
  /** JQ4-19: callback to open comp dialog for a ticket */
  onApplyComp?: (id: string) => void;
  /** JQ4-19: id of the ticket whose comp is in-flight */
  applyingCompId?: string | null;
  /** JQ4-19: whether comps are enabled and the actor is authorized (Scenario 5) */
  compsAuthorized?: boolean;
}

export function MyActiveTickets({
  items,
  onDeliver,
  deliveringId,
  onMarkReady,
  markingReadyId,
  onRegisterCash,
  registeringCashId,
  onApplyComp,
  applyingCompId,
  compsAuthorized = false,
}: MyActiveTicketsProps) {
  return (
    <div className="flex flex-col gap-2">
      {items.map((item) => (
        <PickupRow
          key={item.id}
          ticketNumber={item.ticketNumber}
          plate={item.plate}
          zone={item.zone}
          waitTime={formatWaitTime(item.waitSeconds)}
          status="claimed"
          qrTag={item.qrTag}
          onDeliver={onDeliver ? () => onDeliver(item.id) : undefined}
          delivering={deliveringId === item.id}
          onMarkReady={onMarkReady ? () => onMarkReady(item.id) : undefined}
          markingReady={markingReadyId === item.id}
          ready={Boolean(item.readyForPickupAt)}
          paymentStatus={item.paymentStatus}
          onRegisterCash={onRegisterCash ? () => onRegisterCash(item.id) : undefined}
          registeringCash={registeringCashId === item.id}
          onApplyComp={onApplyComp ? () => onApplyComp(item.id) : undefined}
          applyingComp={applyingCompId === item.id}
          compsAuthorized={compsAuthorized}
        />
      ))}
    </div>
  );
}
